// Add this modal component
import { Modal, ModalBody } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import { CommonFlex, CommonGrid, CommonText } from 'styledComponents/common';
import { AddTaskLocationInfoContainer, AddTaskLocationSection } from 'custom_modules/Tasks/CreateTask/createTaskStyles';
import { ColoredButton, WhiteButton } from 'styledComponents/buttons';


const DeleteGeofenceModal = ({
  isOpen,
  toggle,
  locationToDelete,
  onConfirmDelete
}) => {
  const { t } = useTranslation();

  console.log("locationToDelete", locationToDelete);

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      style={{ marginTop: `2vh`, maxWidth: `500px` }}
    >
      <ModalBody style={{ padding: `0` }}>
        <AddTaskLocationSection style={{
          display: 'block',
          padding: '24px',
          maxWidth: '100%'
        }}>
          <AddTaskLocationInfoContainer style={{
            padding: 0,
            maxWidth: '100%',
            width: '100%'
          }}>
            <CommonText name title fontSize="16px" margin="auto 0 10px 0">
              {t('confirm_delete')}
            </CommonText>

            <CommonText fontSize="16px" margin="0 0 16px 0" color="#333">
              {t('are_you_sure_you_want_to_delete_this_location')}
            </CommonText>

            {/* Location Details Box */}
            <div style={{
              backgroundColor: '#f8f9fa',
              padding: '16px',
              borderRadius: '6px',
              marginBottom: '20px'
            }}>
              <CommonFlex alignItems="center" margin="0 0 12px 0">
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: '#e9ecef',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '12px',
                  fontWeight: 'bold',
                  color: '#495057'
                }}>
                  {locationToDelete?.name.charAt(0).toUpperCase()}
                </div>
                <div>
                  <CommonText fontSize="16px" fontWeight="600">
                    {locationToDelete?.name}
                  </CommonText>
                  <CommonText fontSize="14px" color="#6c757d">
                    {locationToDelete?.office?.name || '-'}
                  </CommonText>
                </div>
              </CommonFlex>

              <CommonGrid gridTemplateColumns="1fr 1fr" gap="12px">
                <div>
                  <CommonText color="#6c757d" fontSize="14px" margin="0 0 4px 0">
                    {t('address')}
                  </CommonText>
                  <CommonText fontWeight="500" fontSize="14px">
                    {locationToDelete?.address}
                  </CommonText>
                </div>
                <div>
                  <CommonText color="#6c757d" fontSize="14px" margin="0 0 4px 0">
                    {t('type')}
                  </CommonText>
                  <CommonText fontWeight="500" fontSize="14px">
                    {t(locationToDelete?.type)}
                  </CommonText>
                </div>
                {locationToDelete?.type === 'circular' && (
                  <div>
                    <CommonText color="#6c757d" fontSize="14px" margin="0 0 4px 0">
                      {t('radius')}
                    </CommonText>
                    <CommonText fontWeight="500" fontSize="14px">
                      {locationToDelete?.radius} m
                    </CommonText>
                  </div>
                )}
              </CommonGrid>
            </div>

            {/* Warning Message */}
            <div style={{
              backgroundColor: '#fff3cd',
              color: '#856404',
              padding: '12px 16px',
              borderRadius: '6px',
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              marginBottom: '20px'
            }}>
              <span style={{ marginRight: '8px' }}>⚠️</span>
              {t('this_action_cannot_be_undone')}
            </div>

            {/* Action Buttons */}
            <CommonGrid
              justifyContent="unset"
              padding="10px 0 0 0"
              margin="30px 0 0"
              borderTop="1px solid #eee"
            >
              <WhiteButton onClick={toggle}>
                {t('cancel')}
              </WhiteButton>
              <ColoredButton
                onClick={onConfirmDelete}
                backgroundColor="#dc3545"
                hoverBackgroundColor="#c82333"
              >
                {t('delete')}
              </ColoredButton>
            </CommonGrid>
          </AddTaskLocationInfoContainer>
        </AddTaskLocationSection>
      </ModalBody>
    </Modal>
  );
};

export default DeleteGeofenceModal;